import React, { createContext, use, useCallback, useContext, useEffect, useState } from 'react';
import axiosInstance from '../services/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import api from 'services/api';


const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartToken, setCartToken] = useState(null);
    const [timeExpiration, setTimeExpiration] = useState(null);
    const [cartQuantity, setQuantity] = useState(0);
    const [loadingCart, setLoadingCart] = useState(true);
    const [cartQuantityForEachDate, setCartQuantityForEachDate] = useState({});
    const [cartItems, setCartItems] = useState([]);
    const {isLoggedIn}= useAuth();

    useEffect(() => {
      // Get cart token from localStorage
      const storedCartToken = localStorage.getItem('cartToken');
      if (storedCartToken) {
        setCartToken(storedCartToken);
        getCart({ tokenPanier: storedCartToken });
      }
      if (cartToken) {
        getCart({ tokenPanier: cartToken });
      }
    }, [isLoggedIn]);

    /* useEffect(() => {
      getCart({ tokenPanier: cartToken });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]); */


    const addToCart = useCallback(async ({ dateId, tarifId, quantity, slug, tokenPanier : tp = null, streamable = false}) => {
      console.log("is auth and add to cart");
      try {
        const response = streamable ? 
        await axiosInstance.post('/cart/add', {
          spectacleDateId: dateId,
          streamTarifId: tarifId,
          quantite: quantity,
          tokenPanier: cartToken || tp,
        })
        :
        await axiosInstance.post('/cart/add', {
          spectacleDateId: dateId,
          categorieTarifaireId: tarifId,
          quantite: quantity,
          tokenPanier: cartToken || tp,
        });
        console.log("set cart token", response.data.panier.token);
        setCartToken(response.data.panier.token);
        localStorage.setItem('cartToken', response.data.panier.token);
        setQuantity((prevQuantity) => prevQuantity + quantity);
        setCartQuantityForEachDate((prevQuantity) => ({
          ...prevQuantity,
          [dateId]: (prevQuantity[dateId] || 0) + quantity
        }));
        console.log("added to cart", response.data);
        return { success: true, data: response.data, tokenPanier: response.data.panier.token };
      } catch (error) {
        if (error.response && error.response.data) {
          return { success: false, errors: error.response.data };
        }
        return { success: false, errors: { message: 'Une erreur est survenue.' } };
      }
    }, [cartToken])
    const getCart = async ({ tokenPanier }) => {
      try {
        setLoadingCart(true);
        const response = await axiosInstance.get(`/cart/current?tokenPanier=${tokenPanier}`);
        if (response.data.panier) {

          let quantity = 0;
          let quantityForEachDate = {};
          setTimeExpiration(response.data.panier.expiredAt);
          response.data.panier.items.forEach(item => {
            quantity += item.quantite
            if (quantityForEachDate[item.spectacleDateId]) {
              quantityForEachDate[item.spectacleDateId] += item.quantite;
            } else {
              quantityForEachDate[item.spectacleDateId] = item.quantite;
            }
          });
          setLoadingCart(false);
          setQuantity(quantity);
          setCartQuantityForEachDate(quantityForEachDate);
          setCartItems(response.data.panier.items);
        } else {
          /* setCartItems([]);
          setQuantity(0);
          setCartQuantityForEachDate({});
          setCartToken(null);
          localStorage.removeItem('cartToken'); */
          setLoadingCart(false);
        }
        return { success: true, data: response.data };
      } catch (error) {
        setLoadingCart(false);
        if (error.response && error.response.data) {
          // Return error details from backend (e.g., field errors)
          return { success: false, errors: error.response.data };
        }
        // Return generic error if no response data
        return { success: false, errors: { message: 'Une erreur est survenue.' } };
      }
    };
    const removeFromCart = async ({ itemId }) => {

      try {
          const response = await axiosInstance.post(`/cart/remove`, {
              panierDetailId: itemId,
              tokenPanier: cartToken
          });
          return { success: true, data: response.data };
      } catch (error) {
          if (error.response && error.response.data) {
          // Return error details from backend (e.g., field errors)
          return { success: false, errors: error.response.data };
          }
          // Return generic error if no response data
          return { success: false, errors: { message: 'Une erreur est survenue.' } };
      }
    }

    const checkDisponibility = async ({ dateId, quantity }) => {
      const response = await api.get(`/spectacle_date/disponibilites/${dateId}`);
      console.log(response);
      if (!response || !response.data) {
        return { success: false, errors: { message: 'Erreur lors de la vérification de la disponibilité.' } };
      }
      
      if (response.data && response.data.availablePlacesForFront) {
        console.log("quantity", quantity);
        console.log("available", response.data.availablePlacesForFront);
        
        if (response.data.availablePlacesForFront >= quantity) {
            return { success: true, data: response.data };
        }
        return { success: false, errors: { message: 'Quantité demandée non disponible.' } };
      }
      return { success: false, errors: { message: 'Erreur lors de la vérification de la disponibilité.' } };
    }

    const emptyCart = async () => {
      try {
        const response = await axiosInstance.post('/cart/remove-all', { tokenPanier: cartToken });
        setCartItems([]);
        setQuantity(0);
        setCartQuantityForEachDate({});
        setCartToken(null);
        localStorage.removeItem('cartToken');
        return { success: true, data: response.data };
      } catch (error) {
        if (error.response && error.response.data) {
          return { success: false, errors: error.response.data };
        }
        return { success: false, errors: { message: 'Une erreur est survenue.' } };
      }
    };

    const relaodCart = async () => {
      await getCart({ tokenPanier: cartToken });
    }


    return (
        <CartContext.Provider value={{cartToken, cartQuantity, setQuantity, cartItems, cartQuantityForEachDate, setCartItems, getCart, addToCart, removeFromCart, relaodCart, checkDisponibility, emptyCart, loadingCart, timeExpiration}}>
            {children}
        </CartContext.Provider>
    );
};

// Hook d'accès
export const useCart = () => useContext(CartContext);
